import { styled } from '@mui/material';

export const Option = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
